import * as z from 'zod';

// The Отчеты (Reports) screen is one read-only payload with three sections, one
// per tab: branch sales, operational analytics, and the detailed delivery log.

/* ── Tab 1: Продажи по филиалам (sales by branch) ──────────────────────────── */

export const branchSalesSchema = z.object({
  id: z.union([z.string(), z.number()]),
  name: z.string(),
  address: z.string(),
  sales: z.string(),
  newCustomers: z.number().int(),
  deliveries: z.number().int().nonnegative(),
  avgDeliveryTime: z.string(),
  successRate: z.number().min(0).max(100),
  topProduct: z.string(),
  topProductShare: z.number().min(0).max(100).nullable().default(null),
});
export type BranchSales = z.infer<typeof branchSalesSchema>;

/* ── Tab 2: Операционная аналитика (operational analytics) ─────────────────── */

export const analyticsBarSchema = z.object({
  label: z.string(),
  value: z.number().nonnegative(),
});
export type AnalyticsBar = z.infer<typeof analyticsBarSchema>;

export const operationalMetricIconSchema = z.enum([
  'prepTime',
  'courierWait',
  'deliveryTime',
]);
export type OperationalMetricIcon = z.infer<typeof operationalMetricIconSchema>;

export const operationalMetricSchema = z.object({
  id: z.union([z.string(), z.number()]),
  title: z.string(),
  icon: operationalMetricIconSchema.default('prepTime'),
  value: z.string(),
  unit: z.string(),
  delta: z.string(),
  deltaPositive: z.boolean().default(true),
  bars: z.array(analyticsBarSchema),
  peakIndex: z.number().int().nonnegative(),
});
export type OperationalMetric = z.infer<typeof operationalMetricSchema>;

/* ── Tab 3: Отчеты по доставке (detailed delivery log) ─────────────────────── */

export const deliveryLogRowSchema = z.object({
  id: z.union([z.string(), z.number()]),
  reference: z.string(),
  branchName: z.string(),
  courierFound: z.string(),
  arrivedAtSender: z.string(),
  waiting: z.string(),
  pickedUp: z.string(),
  onTheWay: z.string(),
  arrivedAtRecipient: z.string(),
});
export type DeliveryLogRow = z.infer<typeof deliveryLogRowSchema>;

/* ── The whole Reports payload ─────────────────────────────────────────────── */

export const deliveryReportSchema = z.object({
  branchSales: z.array(branchSalesSchema),
  operationalMetrics: z.array(operationalMetricSchema),
  deliveryLog: z.array(deliveryLogRowSchema),
});
export type DeliveryReport = z.infer<typeof deliveryReportSchema>;
